import { css } from '@emotion/react';
import React from 'react';
import { buildCSSWithLength } from '../../styles';

export interface TableColGroupProps {
  cols: Array<{ width?: number; minWidth?: number }>;
}

export const TableColGroup = ({ cols }: TableColGroupProps) => {
  return (
    <colgroup>
      {cols.map(({ width, minWidth }, index) => (
        <col
          key={index}
          span={1}
          css={[
            css`
              ${minWidth && `${buildCSSWithLength('min-width', minWidth)}`};
              ${`${buildCSSWithLength('width', width ?? 'auto')}`};
              ${width && !minWidth && `${buildCSSWithLength('min-width', width)}`};
            `,
          ]}
        />
      ))}
    </colgroup>
  );
};
